// extracted by mini-css-extract-plugin
export default {"actionsWrapper":"d1cLUEb9fMh5i_JKObud","actionLabel":"Eh8ZvDSergoY2a8BMZYu"};